export default "__VITE_ASSET__27ac3f74__"